// extracted by mini-css-extract-plugin
module.exports = {"banner":"ob_RuOuBJ","item":"ob_nyPas2","title":"ob_CetyCV","arrow":"ob_cDdoih"};